<script lang="ts">
  import type { Distributor } from "@shared/types/Distributor";
  import { Icon } from "@getprovi/craft-svelte";
  import { TagSolid } from "@getprovi/craft-svelte-icons";
  import InformationCard from "./InformationCard.svelte";
  import {
    DistributorEntity,
    DistributorPLPModalEntity,
    DistributorPLPModalType,
    DistributorPLPModalValue,
  } from "@shared/services/event_tracking/entities";
  import { v4 as uuidv4 } from "uuid";

  export let distributor: Distributor;
  export let showNoDiscountCard: boolean = true;
  //@ts-ignore
  const constants = window.C;
  $: hasDiscounts = distributor?.id
    ? constants.HAS_DISCOUNT_PRICING_DISTRIBUTOR_IDS.includes(distributor.id)
    : false;

  $: discountDetailsEntities = distributor?.id
    ? [
        new DistributorPLPModalEntity({
          modalType: DistributorPLPModalType.Discount,
          value: DistributorPLPModalValue.DiscountDetails,
        }),
        DistributorEntity.fromDistributor(distributor),
      ]
    : undefined;

  $: noDiscountDetailsEntities = distributor?.id
    ? [
        new DistributorPLPModalEntity({
          modalType: DistributorPLPModalType.Discount,
          value: DistributorPLPModalValue.NoDiscountDetails,
        }),
        DistributorEntity.fromDistributor(distributor),
      ]
    : undefined;
  const discountCardId = `information-card-discount-${uuidv4()}`;
  const noDiscountCardId = `information-card-no-discount-${uuidv4()}`;
</script>

<style>
  :global(.icon-container.discount) {
    background-color: #c5fcd8;
  }

  :global(.icon-container.discount svg) {
    color: #348072;
  }

  :global(.icon-container.no-discount) {
    background-color: #eff0f0;
  }

  :global(.icon-container.no-discount svg) {
    color: #595959;
  }

  :global([data-testid="discount-details-modal"] footer button:first-child),
  :global([data-testid="discount-details-modal"] footer > div > button:first-child),
  :global([data-testid="no-discount-details-modal"] footer button:first-child),
  :global([data-testid="no-discount-details-modal"] footer > div > button:first-child) {
    display: none !important;
  }
</style>

{#if hasDiscounts}
  <InformationCard
    shouldShow={true}
    iconContainerClass="discount"
    heading="Shares Discounts"
    description="This distributor posts discounts on Provi!"
    modalTitle="Shares Discounts"
    modalDescription="This distributor shares discounts with Provi! Browse all discounts available for better order total accuracy. As always, your distributor invoice will reflect typical pricing and deals applied by your rep."
    modalTestId="discount-details-modal"
    trackingEventName="distributor_plp_discount_card_see_details_button"
    trackingEntities={discountDetailsEntities}
    trackingId={discountCardId}
  >
    <svelte:fragment slot="icon">
      <Icon iconName={TagSolid} color="brand" size="icon-lg" />
    </svelte:fragment>
  </InformationCard>
{/if}

{#if !hasDiscounts && showNoDiscountCard}
  <InformationCard
    shouldShow={true}
    iconContainerClass="no-discount"
    heading="Discounts Not Shared"
    description="But your typical discounts will be applied on your invoice."
    modalTitle="Discounts Not Shared"
    modalDescription="This distributor doesn't share discounts with Provi, but typical pricing and deals will be applied by your rep. Your distributor invoice will reflect applied discounts."
    modalTestId="no-discount-details-modal"
    trackingEventName="distributor_plp_discount_card_see_details_button"
    trackingEntities={noDiscountDetailsEntities}
    trackingId={noDiscountCardId}
  >
    <svelte:fragment slot="icon">
      <Icon iconName={TagSolid} color="neutral" size="icon-lg" />
    </svelte:fragment>
  </InformationCard>
{/if}
